import { EditModelComponent } from "./edit-model.component";
import { connect } from 'react-redux';
import { AppState } from '../../app.state';

export const EditModel = connect(
    (state: AppState) => ({ sState: state }),
)(EditModelComponent as any) as unknown as typeof EditModelComponent;